module.exports = __webpack_public_path__ + "img/arrow-variant-expand.551e47a4.svg";